import { z } from "zod";
import { IdentityRole } from "./Identity.js";

export enum FeatureId {
  BuildMode = "build-mode",
  CreateMode = "create-mode",
  DashboardAssistant = "dashboard-assistant",
  Dashboard = "dashboard",
  Tasks = "tasks",
  SharedNote = "shared-note",
  Team = "team",
  Network = "network",
  Workspace = "workspace",
  Notes = "notes",
  Sales = "sales",
  Site = "site",
  DocumentAnalysis = "document-analysis",
  Zapier = "zapier",
}

const FeatureSettingValueSchema = z.discriminatedUnion("featureId", [
  z.object({
    featureId: z.literal(FeatureId.SharedNote),
    content: z.string(),
  }),
]);

export const FeatureSettingFiltersSchema = z.object({
  role: z.enum(IdentityRole).optional(),
  featureId: z.enum(FeatureId).optional(),
  enabled: z.boolean().optional(),
});

export const FeatureSettingGetSchema = z.object({
  role: z.enum(IdentityRole),
  featureId: z.enum(FeatureId),
});

export const FeatureSettingUpsertSchema = z.object({
  role: z.enum(IdentityRole),
  featureId: z.enum(FeatureId),
  enabled: z.boolean().optional(),
  value: FeatureSettingValueSchema.optional(),
});

export type FeatureSettingFilters = z.infer<typeof FeatureSettingFiltersSchema>;
export type FeatureSettingGet = z.infer<typeof FeatureSettingGetSchema>;
export type FeatureSettingUpsert = z.infer<typeof FeatureSettingUpsertSchema>;
export type FeatureSettingValue = z.infer<typeof FeatureSettingValueSchema>;
